import React, { createContext, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useOnboarding } from '../../hooks/useOnboarding';

const OnboardingContext = createContext();

export const useOnboardingContext = () => {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error('useOnboardingContext must be used within OnboardingProvider');
  }
  return context;
};

export const OnboardingProvider = ({ children, autoShow = true, userId = null, email = null }) => {
  const onboarding = useOnboarding();
  const location = useLocation();

  // Only show onboarding on dashboard routes, not on setup/config routes
  const shouldShowOnboarding = () => {
    const currentPath = location.pathname;

    // Don't show onboarding on setup, auth, or config routes
    const excludedRoutes = ['/setup', '/sign-in', '/sign-up', '/verify-email'];
    const isExcludedRoute = excludedRoutes.some(route => currentPath.startsWith(route));

    // Only show on main dashboard routes
    const dashboardRoutes = ['/my-chest', '/profile', '/treasure', '/shared'];
    const isDashboardRoute = dashboardRoutes.some(route => currentPath.startsWith(route));

    return !isExcludedRoute && isDashboardRoute;
  };

  useEffect(() => {
    if (autoShow && (userId || email) && shouldShowOnboarding()) {
      onboarding.checkAndShowOnboarding(userId, email);
    }
  }, [autoShow, userId, email, location.pathname]);

  const contextValue = {
    ...onboarding,
    showOnboarding: () => onboarding.checkAndShowOnboarding(userId, email),
    forceShowOnboarding: () => onboarding.forceShowOnboarding(userId, email)
  };

  return (
    <OnboardingContext.Provider value={contextValue}>
      {children}
    </OnboardingContext.Provider>
  );
};